<template>
    <b-navbar toggleable="sm">
        <b-navbar-brand>
            <img src="pic/pmis-logo.png">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto menu-flex">
                <b-nav-item target="_blank" href="http://pmis.ijs.si">PMiS</b-nav-item>
<!--                <div class="vl"></div>-->
                <router-link class="nav-item" to="/igralnica">Igralnica</router-link>
                <router-link class="nav-item" :to="{ path: '/igralnica', hash: '#o_igralnici' }">O igralnici</router-link>
                <router-link class="nav-item" :to="{ path: '/igralnica', hash: '#igrala' }">Igrala</router-link>
                <b-nav-item target="_blank" :href="pmisTrznicaResitevUrl">Tržnica rešitev</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
    export default {
        name: "Menu",
        methods: {
            smoothScroll(refName) {
                var element = document.getElementById(refName);
                var top = element.offsetTop;
                window.scrollTo({top: top, behavior: 'smooth'});
            }
        },
        computed: {
            pmisTrznicaResitevUrl: () => {
                return window._env_.PMIS_TRZNICA_RESITEV_URL;
            }
        }

    }
</script>

<style lang="scss" scoped>

    .vl {
        border-left: 1px solid lightgray;
        height: 45px;
    }

    .menu-flex{
        display: flex;
        align-items: center;
    }

    .nav-item {
        margin: 8px;
        font-family: "Roboto" !important;
        font-size: 1em;
        color: rgba(0, 0, 0, 0.5);
        padding-left: 2.5vw;
    }

    .nav-item:hover {
        color: $pmis-grey;
        TEXT-DECORATION: none;
        font-weight: inherit
    }

    .navbar {
        padding-bottom: 0px;
    }
</style>
